import { createContext, useContext, type ReactNode } from 'react';
import type { SegmentationFieldDefinition } from '@/shared/types/segmentation';

/**
 * O catálogo de campos é o mesmo pra todos os nós do canvas -- Context evita
 * duplicar em `data` de cada nó (que o React Flow não deixa injetar via
 * `nodeTypes` de outra forma, já que node components só recebem `NodeProps`).
 */
const SegmentationFieldCatalogContext = createContext<SegmentationFieldDefinition[]>([]);

export function SegmentationFieldCatalogProvider({
  value,
  children,
}: {
  value: SegmentationFieldDefinition[];
  children: ReactNode;
}) {
  return (
    <SegmentationFieldCatalogContext.Provider value={value}>{children}</SegmentationFieldCatalogContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSegmentationFieldCatalog(): SegmentationFieldDefinition[] {
  return useContext(SegmentationFieldCatalogContext);
}
